<template>
  <div>
    <b-row class="pb-2">
      <b-col sm="3" class="mt-1 formLabel">새 비밀번호</b-col>
      <b-col sm="9">
        <b-form-input 
          v-model="password" 
          type="password"
          name="password" 
          :class="{error: errors.has('password')}" 
          v-validate="'required'"
          placeholder="변경할 비밀번호를 입력하세요"
          ref="passwordInput"
        ></b-form-input>
      </b-col>
    </b-row>

    <b-row class="pb-2">
      <b-col sm="3" class="mt-1 formLabel">비밀번호 확인</b-col>
      <b-col sm="9">
        <b-form-input 
          v-model="passwordConfirm" 
          type="password"
          name="passwordConfirm" 
          :class="{error: errors.has('passwordConfirm')}" 
          v-validate="'required'"
          placeholder="비밀번호를 한번 더 입력하세요"
        ></b-form-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'PasswordChangeModal',
  data() {
    return {
      password: '',
      passwordConfirm: '',
    }
  },
  methods: {
    // 폼 초기화
    resetForm() {
      this.password = '';
      this.passwordConfirm = '';
      this.$validator.reset();
    },
    // 유효성 검사
    async validateForm() {
      const result = await this.$validator.validateAll();
      const hasNoErrors = !this.errors.items || this.errors.items.length === 0;
      
      // 1-1. 필수 입력 체크
      if (!result && !hasNoErrors) {
        const userInfo = this.$store.getters.getUserInfo;
        console.log(userInfo);
         return { valid: false, msg: '비밀번호를 입력해주세요.' };
      }

      // 1-2. 비밀번호 복잡도 체크 (영문/숫자/특수문자 조합, 8자 이상)
      // 정규식: 최소 8자 이상, 하나 이상의 문자, 하나 이상의 숫자, 하나 이상의 특수문자
      const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      if (!passwordRegex.test(this.password)) {
        return { valid: false, msg: '비밀번호는 영문, 숫자, 특수문자를 포함하여 8자 이상이어야 합니다.' };
      }

      // 2. 일치 여부 체크
      // 3. 3개 이상 연속되거나 동일한 문자/숫자 체크
      if (this.checkConsecutive(this.password)) {
        return { valid: false, msg: '비밀번호에 3개 이상 연속되거나 동일한 문자/숫자는 사용할 수 없습니다.' };
      }

      // 4. 휴대전화 번호 포함 여부 체크
      const userInfo = this.$store.getters.getUserInfo;
      console.log(userInfo);
      if (userInfo && userInfo.mobile) {
        let cleanMobile = userInfo.mobile.replace(/-/g, ''); // 하이픈 제거
        if (cleanMobile.startsWith('010')) {
          cleanMobile = cleanMobile.substring(3);
        }
        // 휴대전화 번호가 있고, 비밀번호에 포함되어 있다면
        if (cleanMobile.length > 0 && this.password.includes(cleanMobile)) {
          return { valid: false, msg: '비밀번호에 휴대전화 번호를 포함할 수 없습니다.' };
        }
      }

      // 5. 일치 여부 체크
      if (this.password !== this.passwordConfirm) {
        return { valid: false, msg: '비밀번호가 일치하지 않습니다.' };
      }

      return { valid: true };
    },
    // 입력된 비밀번호 반환
    getPassword() {
      return this.password;
    },
    checkConsecutive(password) {
      if (!password) return false;

      // 1. 3개 이상 동일한 문자/숫자 (aaa, 111, !!!)
      if (/(\w)\1\1/.test(password)) {
        return true;
      }

      // 2. 3개 이상 연속된 문자/숫자 (abc, 123)
      for (let i = 0; i < password.length - 2; i++) {
        let char1 = password.charCodeAt(i);
        let char2 = password.charCodeAt(i + 1);
        let char3 = password.charCodeAt(i + 2);

        // 오름차순 (123, abc)
        if (char1 + 1 === char2 && char2 + 1 === char3) {
          return true;
        }
      }
      
      return false;
    }
  }
}
</script>

<style scoped>
.formLabel {
  font-weight: 600;
  display: flex;
  align-items: center;
}
input.error {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4;
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordChangeModal.vue